import LogoIcon from "../../../assets/images/icon/logo.png";
import { ReactComponent as GlobeIcon } from "../../../assets/images/icon/global.svg";
import { ReactComponent as HeaderBgIcon } from "../../../assets/images/picture/header__BG.svg";
import { Link } from "react-router-dom";

function Header() {
  return (
    <>
      <header>
        <HeaderBgIcon className="header__bg" />
        <div className="container">
          <div className="wrapper">
            <div className="content">
              <Link to="/">
                <div className="logo">
                  <img src={LogoIcon} alt="" />
                </div>
              </Link>
              <a href="http://ai-nature.com/" target="_blank">
                <GlobeIcon />
              </a>
            </div>
          </div>
        </div>
      </header>
    </>
  );
}

export default Header;
